import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PrintgroupService {

  constructor(private http: HttpClient) { }

  postPrintgroup(formData){
    return this.http.post(environment.apiBaseURI + '/PrintGroup', formData)
  }

  putPrintgroup(formData){
    return this.http.put(environment.apiBaseURI + '/PrintGroup/' + formData.id, formData)
  }

  getPrintgroupList(param: any){
    return this.http.post(environment.apiBaseURI + '/PrintGroup/GetPrintGroupDetails', param);
  }

  getPrintGroups(){
    return this.http.get(environment.apiBaseURI + '/PrintGroup/');
  }

  deletePrintgroup(id){
    return this.http.delete(environment.apiBaseURI + '/PrintGroup/' + id);
  }

  dataInsert(strcmd:any){
    return this.http.get(environment.apiBaseURI + '/PrintGroup/InsertPrintGroups?strcmd=' + strcmd);
  }
}
